<!--
 * @Date: 2020-05-18 09:56:27
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-26 11:32:48
 * @FilePath: /xy-pc/src/views/userCenter/myQuestion/index.vue
--> 

<template>
  <div class="activePain" style="width:100%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="我的问题" name="first" style>
        <div style="min-height:50vh">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index" class="list">
              <!-- 问题内容 -->
              <div class="title ellipsis-1">
                <span class="label">问</span>
                <span>{{item.content}}</span>
              </div>
              <!-- 问题时间 -->
              <div class="contant_text2">{{item.crated_at}}</div>
              <!-- 回答内容 -->
              <div class="contant_text3" v-if="item.answer">
                <span class="return">回复:</span>
                <span class="reback ritchHtml" v-html="item.answer"></span>
              </div>
              <!-- 回答时间 -->
              <div class="contant_text3 ellipsis-1" v-if="item.answer">{{item.answerd_at}}</div>
            </div>
          </div>
          <div v-if="dataList.length==0">
            <el-card>
              <p style="text-align:center;margin-top:130px;margin-bottom:100px">您暂时还未提问，快去学习课程并提问吧!</p>
            </el-card>
          </div>
        </div>
        <div style="margin:20px 0 40px;text-align: center;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="limit"
            layout=" sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- <el-button type="primary">提问</el-button> -->
  </div>
</template>

<script>
export default {
  name: "student_message",

  data() {
    return {
      activeName: "first",
      dataList: [],
      page: 1,
      limit: 10,
      total: 0
    };
  },

  created() {
    this.getPageList();
  },

  methods: {
    getPageList() {
      this.$http({
        url: "api/v1/auth/course-questions",
        method: "get",
        params: { page: this.page, limit: this.limit }
      }).then(res => {
        if (res.status == 200) {
          this.total = res.data.total;
          this.dataList = res.data.questions;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getPageList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getPageList();
    }
  }
};
</script>

<style lang="less" scoped>
.return {
  background-color: #fff !important;
  color: #919191 !important;
  font-size: 12px;
  font-weight: bold;
  margin-right: 6px;
}
.list {
  padding: 14px 5px;
  border-bottom: #fafafa solid 1px;
}
.title {
  font-weight: 600;
  color: #666;
  font-size: 15px;
  margin-bottom: 10px;
}
.contant_list:hover {
  cursor: pointer;
  background-color: rgba(250, 250, 250, 1);
}
.reback {
  color: #0081e6 !important;
  font-size: 14px;
}
.contant_text2 {
  color: #919191;
  font-size: 14px;
  text-align: left;
}
.contant_text3 {
  color: rgba(128, 128, 128, 1);
  font-size: 15px;
  line-height: 150%;
  text-align: left;
}
.label {
  margin-right: 10px;
  display: inline;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #278bf5;
  padding: 2px 6px;
  font-weight: 400;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
</style>

